import { Component, Input } from '@angular/core';
import { ProofCtBatch } from '../model/ct-batch-model';

@Component({
  selector: 'ct-shared-proof-batch-details',
  template: `
    <div class="border-theme-gray-500 flex gap-4 rounded-md border bg-white px-2 py-1 text-xs">
      <div class="flex flex-col">
        <span class="font-bold">Mandant</span>
        <span>{{ ctBatch.tenant }}</span>
      </div>
      <div class="flex flex-col">
        <span class="font-bold">Schadennummer</span>
        <span
          >{{ ctBatch.claimNumber
          }}{{ ctBatch.businessTransaction ? '-' + ctBatch.businessTransaction : '' }}</span
        >
      </div>
      <div class="flex flex-col">
        <span class="font-bold">Typ</span>
        <span>{{ ctBatch.proofType }}</span>
      </div>
    </div>
  `,
})
export class ProofBatchDetailsComponent {
  @Input({ required: true }) ctBatch!: ProofCtBatch;
}
